import { cn } from "@/lib/chillnn/cn";

type Props = {
	children: React.ReactNode;
};

const daysOfWeek = ["日", "月", "火", "水", "木", "金", "土"];

export const CalendarPanelLayout = ({ children }: Props) => {
	return (
		<div className="space-y-2">
			{/* 曜日ヘッダー */}
			<div className="grid grid-cols-7 gap-3">
				{daysOfWeek.map((dayOfWeek, idx) => {
					const isSunday = dayOfWeek === "日";
					const isSaturday = dayOfWeek === "土";

					return (
						<h6
							className={cn(
								"text-center text-sm", //
								isSunday && "text-pink-400",
								isSaturday && "text-blue-400",
							)}
							key={idx}
						>
							{dayOfWeek}
						</h6>
					);
				})}
			</div>

			{/* カレンダーグリッド */}
			<div className="grid grid-cols-7 gap-3">{children}</div>
		</div>
	);
};
